export type PageCategoryType =
  | 'homepage'
  | 'service'
  | 'technology'
  | 'industry'
  | 'blog'
  | 'case-study'
  | 'campaign'
  | 'page';

export const usePageCategoryForEvent = (
  pathname: string,
  isCampaign?: boolean,
): PageCategoryType => {
  if (pathname === '/') return 'homepage';

  if (pathname.includes('/services')) return 'service';

  if (pathname.includes('/technologies')) return 'technology';

  if (pathname.includes('/industries')) return 'industry';

  if (pathname.includes('/blog')) return 'blog';

  if (pathname.includes('/portfolio')) return 'case-study';

  if (isCampaign) return 'campaign';

  return 'page';
};
